/**
 * Created by TF on 2018/6/20
 */
import axios from 'axios';
let qs = require('qs');

let base = 'http://47.104.248.56:8081';
// let base = 'http://localhost:8081';

var instance = axios.create({
    headers: {
        // 'content-type': 'application/json',
      'Authorization': ''
    }
});
instance.interceptors.request.use(
  config => {
    config.headers.Authorization = localStorage.getItem('Authorization');
    return config
  }, err => {
    return Promise.reject(err)
  });

// 通过code换取网页授权access_token
// export const  get_access_token= params => { return instance.get(`${base}/wechat/auth`, { params: params }) };
export const  get_access_token= params => { return instance.get(`${base}/wechat/wxinfo`, { params: params }) };
// 判断用户是否绑定微信账号
export const  get_isBinding_userInfo= params => { return instance.get(`${base}/wechat/isBindingUserInfo`, { params: params }) };
// 微信个人资料修改
export const  reqWxWebUserEdit= params => { return instance.post(`${base}/wechat/reqWxWebUserEdit`, qs.stringify(params)) };
// 微信修密码
export const  reqWxPassword= params => { return instance.get(`${base}/wechat/passwordUpdate`, { params: params })  };
// 获取微信js权限签名
export const  reqwxConfig= params => { return instance.get(`${base}/wechat/reqwxConfig`, { params: params })  };

// 添加微信请求，使用 localStorage
export const reqGetDictionaryListByCode = params => { return instance.get(`${base}/dictionary/getListByCode`, { params: params } ) };

// 微信个人资料中,修改个人信息
export const  reqWebUserOneById= params => { return instance.get(`${base}/webUser/one`, { params: params }) };

// 微信用户注册
export const reqGetWxRegister = params => { return instance.post(`${base}/webUser/wxRegister`, params) }

// 微信用户注册时发送短信验证码
export const  reqWxPhoneCaptcha= params => { return instance.get(`${base}/webUser/getWxPhoneCaptcha`, { params: params }) }

// 判断用户名是否重复
export const  reqRepeatUsername= params => { return instance.get(`${base}/webUser/RepeatUsername`, { params: params }) }

// 微信端获取图片验证码：
export const reqCodeImg = params => { return instance.get(`${base}/webUser/getCodeImg`, {params: params}) }

// 获取图片验证码是否正确。
export const reqCodeImageIsTrue = params => { return instance.get(`${base}/webUser/getCodeImgIsTrue`, {params: params}) }

// 微信登录
export const reqGetWxLogin = params => { return instance.post(`${base}/webUser/wxLogin`, qs.stringify(params)).then(res => res.data) }

// 关联业务员分享二维码注册的用户
export const reqAddReferrer = params => { return instance.post(`${base}/userCustomer/add`, qs.stringify(params))};

// 微信端在个人中心用户修改密码后重新登录系统(和授权无关，只是单纯的登录)
export const reqWxLoginByChangePwd = params => { return instance.post(`${base}/webUser/wxLoginByChangePwd`, qs.stringify(params)).then(res => res.data) }

// 微信用户找回密码时，获取手机验证码
export const  reqWxForgetPwdCaptcha= params => { return instance.get(`${base}/webUser/getWxForgetPwdCaptcha`, { params: params }) }

// 修改密码，通过手机号
export const reqChangePwd = params => { return instance.post(`${base}/webUser/resetPwd`, params) };

// 微信用户找回密码时，验证手机验证码是否正确
export const reqGoWxChangePwd = params => { return instance.post(`${base}/webUser/goWxChangePwd`, params) }

// 微信端我的出借详情
export const  reqWxMyLoanPage= params => { return instance.get(`${base}/webUser/wxLoanPage`, { params: params })  };
export const  reqMyCustomerInfo= params => { return instance.get(`${base}/userCustomer/wxCustomerInfo`, { params: params })  };
export const  reqWxMyBorrowPage= params => { return instance.get(`${base}/webUser/wxBorrowPage`, { params: params })  };
export const  reqWxMyAssignmentDebtPage= params => { return instance.get(`${base}/webUser/wxAssignmentDebtPage`, { params: params })  };


// 通过id查询
export const  reqWebUserOne= params => { return instance.get(`${base}/webUser/selectByTokeId`, { params: params }) };

// 微信统计我的出借总数量
export const  reqWxMyLoanCount= params => { return instance.get(`${base}/webUser/wxLoanContractAmountAndTotals`, { params: params })  };

export const  reqWxMyBorrowCount= params => { return instance.get(`${base}/webUser/wxBorrowContractAmountAndTotals`, { params: params })  };

export const  reqWxMyAssignmentDebtCount= params => { return instance.get(`${base}/webUser/wxAssignmentDebtContractAmountAndTotals`, { params: params })  };

export const  reqWxMyCustomCount= params => { return instance.get(`${base}/userCustomer/wxMyCustomCount`, { params: params })  };


// 借入项目查询：
export const reqBorrowProjectListPage = params => {
  return instance.get(`${base}/borrowProject/list`, {params: params})
};

// 出借项目查询：
export const reqLoanProjectListPage = params => {
  return instance.get(`${base}/loanProject/list`, {params: params})
};

// 出借项目通过项目id查询项目
export const reqGetOneLoanProject = params => {
  return instance.get(`${base}/loanProject/one`, {params: params})
};

// 借入项目通过项目id查询项目
export const reqGetOneBorrowProject = params => {
  return instance.get(`${base}/borrowProject/one`, {params: params})
};

// 债权转让通过项目id查询项目
export const reqGetOneAssignmentDebt = params => {
  return instance.get(`${base}/assignmentDebt/one`, {params: params})
};

// 债权转让查询：
export const reqAssignmentDebtListPage = params => {
  return instance.get(`${base}/assignmentDebt/list`, {params: params})
};

//项目意向
// 借入意向新增
export const reqBorrowIntentionAdd = params => { return instance.post(`${base}/borrowIntention/add`, qs.stringify(params) ) };

// 出借意向新增
export const reqLoanIntentionAdd = params => { return instance.post(`${base}/pLoanIntention/add`, qs.stringify(params) ) };

// 债权转让意向新增
export const reqAssignmentIntentionAdd = params => { return instance.post(`${base}/assignmentIntention/add`, qs.stringify(params) ) };

// 查询是否有未处理的意向
export const reqQueryUnprocessedIntention = params => { return instance.get(`${base}/borrowIntention/hasUnprocessedIntention`, { params: params } ) };

// 根据项目id查询借入意向 分页
export const reqGetBorrowIntentionByProjIdPage = params => { return instance.get(`${base}/borrowIntention/queryByProjIdPage`, { params: params } ) };

// 根据项目id查询出借意向 分页
export const reqGetLoanIntentionByProjIdPage = params => { return instance.get(`${base}/pLoanIntention/queryByProjIdPage`, { params: params } ) };

// 根据项目id查询债权转让意向 分页
export const reqGetAssignmentIntentionByProjIdPage = params => { return instance.get(`${base}/assignmentIntention/queryByProjIdPage`, { params: params } ) };


export const reqGetAttachmentsByProjId = params => {return instance.get(`${base}/attachment/getListByProjId`, {params: params})};

// 验证用户登录状态
export const reqValidateWebUser = params => { return instance.get(`${base}/validateWebUser`, { params: params }) };

export const reqGetOneByCode = params => { return instance.get(`${base}/dictionary/one`, { params: params }) };

export const reqGetDictionaryByIdList = params => { return instance.get(`${base}/dictionary/getByIdList`, { params: params } ) };


export const uploadFileURL = `${base}/file/uploadFile`;
export const downloadFileURL = `${base}/file/downloadFile/`;



// WEBPACK FOOTER //
// ./src/api/weixin-api.js